// Script pour ouvrir Shopify Inbox lors d'un clic sur un lien #toggleChat
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    // Vérifie si le clic est sur un lien ou un élément contenant un lien
    let target = e.target;
    while (target && target !== document.body) {
      if (target.tagName === 'A' && target.getAttribute('href') === '#toggleChat') {
        e.preventDefault();
        
        // Shopify Inbox expose window.ShopifyInbox et sa méthode open()
        if (window.ShopifyInbox && typeof window.ShopifyInbox.open === 'function') {
          window.ShopifyInbox.open();
        } else {
          // Fallback : tente de cliquer sur le bouton d'ouverture du chat si présent
          var chatElem = document.querySelector("inbox-online-store-chat");
          var chatButton = chatElem?.shadowRoot?.querySelector(".chat-toggle");
          if (chatButton) {
            chatButton.click();
          }
        }
        break;
      }
      target = target.parentElement;
    }
  });
});

